<ng-container *ngTemplateOutlet="countdownTemplate; context: { below: !isBelowCountdown }" />
<h3 *ngIf="title" class="title">{{ title }}</h3>
<div *ngIf="subtitle" class="subtitle copy-m">{{ subtitle }}</div>
<ng-container *ngTemplateOutlet="countdownTemplate; context: { below: isBelowCountdown }" />

<ng-template #countdownTemplate let-below="below">
  <div *ngIf="below" class="countdown-container">
    <div *ngIf="countDownReached && postCountdownLabel" class="pre-countdown-text">
      {{ postCountdownLabel }}
    </div>
    <div *ngIf="countdownDate && !countDownReached" class="counter">
      <mb-countdown
        (finished)="finished()"
        [countdownTo]="countdownDate"
        [countdownLabel]="countdownLabel || ''"
        [countdownType]="showDaysOnly ? countdownType.DAYS : countdownType.FULL"
      ></mb-countdown>
    </div>
  </div>
</ng-template>
